import { render, staticRenderFns } from "./OrderCancellation.vue?vue&type=template&id=9b2b5962"
import script from "./OrderCancellation.vue?vue&type=script&lang=js"
export * from "./OrderCancellation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports